/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Jaune",
  logo_name: "Jaune",
  nickname: "Jaune",
  full_name: "Jonathan Prevedan",
  subTitle:
    "Développeur Web",
  
  mail: "mailto:jonprev07@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/jonathan-prevedan",
  linkedin: "https://www.linkedin.com/in/jonathan-prevedan/",
  gmail: "jonprev07@gmail.com",
 
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Développer des interfaces Front end pour votre application web et mobile",
        "⚡ Créer des applications web responsives",
        "⚡ Développer des applications mobiles",
        "⚡ Crée un service Backend en PHP",
        "⚡ Intégration d'API externes"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: {
            color: "#FF2D20",
          },
        },
        {
          skillName: "CodeIgniter",
          fontAwesomeClassname: "simple-icons:codeigniter",
          style: {
            color: "#EF4223",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        // {
        //   skillName: "NodeJS",
        //   fontAwesomeClassname: "simple-icons:node-dot-js",
        //   style: {
        //     color: "#339933",
        //   },
        // },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        // {
        //   skillName: "MongoDB",
        //   fontAwesomeClassname: "simple-icons:mongodb",
        //   style: {
        //     color: "#439743",
        //   },
        // },
        // {
        //   skillName: "GraphQL",
        //   fontAwesomeClassname: "simple-icons:graphql",
        //   style: {
        //     color: "#DE33A6",
        //   },
        // },
        // {
        //   skillName: "Android",
        //   fontAwesomeClassname: "simple-icons:android",
        //   style: {
        //     color: "#3DDC84",
        //   },
        // },
        // {
        //   skillName: "Java",
        //   fontAwesomeClassname: "simple-icons:java",
        //   style: {
        //     color: "#f89820",
        //   },
        // },
        // {
        //   skillName: "Flutter",
        //   fontAwesomeClassname: "simple-icons:flutter",
        //   style: {
        //     color: "#02569B",
        //   },
        // },
        // {
        //   skillName: "Dart",
        //   fontAwesomeClassname: "simple-icons:dart",
        //   style: {
        //     color: "#29B0EE",
        //   },
        // },
        // {
        //   skillName: "Visual Basic",
        //   fontAwesomeClassname: "simple-icons:dot-net",
        //   style: {
        //     color: "#029FCE",
        //   },
        // },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "simple-icons:apache",
          style: {
            color: "#CA1A22",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        // {
        //   skillName: "C",
        //   fontAwesomeClassname: "simple-icons:c",
        //   style: {
        //     color: "#E94E32",
        //   },
        // },
        // {
        //   skillName: "C++",
        //   fontAwesomeClassname: "simple-icons:cplusplus",
        //   style: {
        //     color: "#E94E32",
        //   },
        // },
        // {
        //   skillName: "Python",
        //   fontAwesomeClassname: "simple-icons:python",
        //   style: {
        //     color: "#3776AB",
        //   },
        // },
      ],
    },
    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Experience hosting and managing websites",
    //     "⚡ Experience with Continuous Integration",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Netlify",
    //       fontAwesomeClassname: "simple-icons:netlify",
    //       style: {
    //         color: "#38AFBB",
    //       },
    //     },
    //     {
    //       skillName: "Heroku",
    //       fontAwesomeClassname: "simple-icons:heroku",
    //       style: {
    //         color: "#6863A6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "PostgreSQL",
    //       fontAwesomeClassname: "simple-icons:postgresql",
    //       style: {
    //         color: "#336791",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //     {
    //       skillName: "GitHub Actions",
    //       fontAwesomeClassname: "simple-icons:githubactions",
    //       style: {
    //         color: "#5b77ef",
    //       },
    //     },
    //   ],
    // },
  ],
};





// Experience Page
const experience = {
  title: "Expériences professionnelles",
  subtitle: "",
  description:
    "Je suis actuellement à l'écoute du marché",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Expérience",
      experiences: [
        {
          title: "Développeur Web",
          company: "DDL DEV",
          company_url: "https://comtuveux.fr/",
          logo_path: "comtuveux.png",
          duration: "Février 2022 - now",
          location: "Office / Remote",
          description:
          `Développement d'une solution de prise de rendez-vous en ligne. (PHP 7+, SQL, Redis, jQuery, Javascript)
          `,
          color: "#0071C5",
        },
        {
          title: "Concepteur Developpeur d'Application - Alternance",
          company: "l'Aleph",
          company_url: "https://www.laleph.com/",
          logo_path: "valora.png",
          duration: "Septembre 2020 - Juillet 2021",
          location: "Office / Remote",
          description:
          `De la conception au développement des différents projets que l'on m'a confiés. (PHP 7+, SQL, ReactJS)
          `,
            // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
          color: "#0071C5",
        }
        
      ],
    },
    {
      title: "Formations",
      experiences: [
        {
          title: "Concepteur Développeur d'Application",
          company: "La Plateforme",
          company_url: "https://laplateforme.io/",
          logo_path: "cwoc.png",
          duration: "Septembre 2020 - Juillet 2021",
          location: "Marseille",
          description:
            "Formation délivrant un titre RNCP niveau 6 (BAC+3)",
          color: "#4285F4",
        },
        {
          title: "Développeur Web et Web Mobile",
          company: "La Plateforme",
          company_url: "https://laplateforme.io/",
          logo_path: "cwoc.png",
          duration: "Septembre 2019 - Septembre 2020",
          location: "Marseille",
          description:
            "Formation délivrant un titre RNCP niveau 5 (BAC+2)",
          color: "#4285F4",
        }
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projets",
  description:
    "Quelques projets :)",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "intro-bg.jpg",
    description:
      "Vous pouvez me contacter via les différents réseaux ci-dessous ! Je vous répondrais au plus vite ! ",
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Twitter.",
  //   link: "https://twitter.com/Harikrushn9",
  //   avatar_image_path: "blogs_image.svg",
  // },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Application BDE",
     
      description: "Une application mobile permettant aux élèves de pouvoir organise des événements",
      languages: [
        {
          name: "React-native",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "1",
      name: "UberEat like",
  
      description:
        "Une application mobile permettant la commande de repas en ligne",
      languages: [
        
        {
          name: "React-native",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "2",
      name: "API REST",
      description:
        "Une API Restful (CodeIgniter)",
      languages: [
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "SQL",
          iconifyClass: "simple-icons:mysql",
        },
      ],
    },
    {
      id: "3",
      name: "Boutique en ligne",
      description:
        "Boutique en ligne (aucun mode de paiement).",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "SQL",
          iconifyClass: "simple-icons:mysql",
        }
      ],
    },
    {
      id: "4",
      name: "Reservation salle",
      description:
        "Site web permettant de pouvoir réserver une salle",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "SQL",
          iconifyClass: "simple-icons:mysql",
        }
      ],
    },
    {
      id: "3",
      name: "CMS",
      description:
        "Utilisation de WordPress ainsi que WooCommerce",
      languages: [
        {
          name: "WordPress",
          iconifyClass: "logos-wordpress",
        },
      ],
    },
    
      
    
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
